module.exports = "/hwa/_next/static/images/skip-9f6a21aa0e35cc757347c1d0c311d653.png";